// Where the customer portal lives. It is a separate deployable on its own
// domain, so the admin portal cannot derive the URL — it is told at build
// time (scripts/staging-deploy-portals.sh resolves it per environment) and
// falls back to the local dev server.
declare const __ORDER_PORTAL_URL__: string;

export const orderPortalUrl: string = __ORDER_PORTAL_URL__;

/** The storefront a customer sees for this store. */
export function storefrontUrl(rid: string, sid: string): string {
  return `${orderPortalUrl.replace(/\/$/, '')}/r/${rid}/s/${sid}`;
}

/** The link a table's QR code carries — the storefront, with the table known. */
export function tableUrl(rid: string, sid: string, tableId: string): string {
  return `${storefrontUrl(rid, sid)}/t/${tableId}`;
}
